import { Steps } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import Headline from '../../../components/Headline'
import {
  noPackageId,
  packageUploadStage,
  packageUploadStageList,
} from '../../Upload'

import { usePackageInfo } from '../../../hooks/reactQuery/usePackage'
import { useUserWithRedirect } from '../../../hooks/user/useUserWithRedirect'

const UploadPackageHeader = () => {
  const { packageId, stage } =
    useParams<{ packageId: string; stage: packageUploadStage }>()
  const history = useHistory()
  const user = useUserWithRedirect()
  const {
    data: packageAndSticker,
    error,
    isLoading,
  } = usePackageInfo(packageId, user?.sessionToken)

  const curStageIndex = packageUploadStageList.findIndex((el) => el === stage)

  return (
    <div style={{ marginBottom: '24px' }}>
      <Headline
        id={`Upload.PkgCreation.selectPackType.headline.${packageAndSticker?.packType}`}
        defaultMessage=""
        styles={{
          margin: '22px 0px 0px 0px',
          fontFamily: 'NotoSans',
          fontSize: '34px',
          lineHeight: '36px',
          letterSpacing: 0,
        }}
      />
      <Steps
        className=".ant-steps-item-process"
        type="navigation"
        current={curStageIndex}
        onChange={(clickedStageIndex) => {
          if (packageId === noPackageId) {
            return
          }
          const nextStage = packageUploadStageList[clickedStageIndex]
          history.push(nextStage)
        }}
      >
        {[...new Array(packageUploadStageList.length)].map((s, idx) => (
          <Steps.Step
            status={
              curStageIndex < idx
                ? 'wait'
                : curStageIndex === idx
                ? 'process'
                : 'finish'
            }
            key={idx}
            title={
              <span className="pack-progress-step-title">
                <FormattedMessage
                  id={`Upload.packagesInProgress.step.${packageUploadStageList[idx]}`}
                />
              </span>
            }
          />
        ))}
      </Steps>
      {/* <PackProgressStep selectedKey="package-info" /> */}
    </div>
  )
}

export default UploadPackageHeader
